<script setup lang="ts">
// Vue & Plugins
import { onMounted, reactive, watch } from 'vue'
import { gsap } from 'gsap'

// Data
const { value } = defineProps<{
  value: number
}>()

const tweened = reactive({
  number: 0,
})

watch(
  () => value,
  (newVal) => {
    gsap.to(tweened, {
      duration: 1,
      number: newVal,
    })
  },
)

onMounted(() => {
  tweened.number = value
})
</script>

<template>
  <span class="tweened-number">{{ tweened.number.toFixed(0) }}</span>
</template>
